import { Middleware, MiddlewareAPI } from "@reduxjs/toolkit";
import { io, Socket } from "socket.io-client";

import { log } from "@/utils/useLogger";
import { AppThunkDispatch, RootState } from "@/store";
import { setEventListeners } from "./setEventListeners";
import { genGraph, progressImageSet, runESRGAN } from "@/reducer/designslice";

const socketioLog = log.child({ namespace: "socketio" });

const socketMiddleware: Middleware = (storeApi: MiddlewareAPI<AppThunkDispatch, RootState>) => (next) => (action) => {
  let areListenersSet = false;
  const socketUrl = "https://www.aldgptai.com";
  const socketOptions = {
    timeout: 60000,
    transports: ["websocket"],
    path: "/image.io",
    query: { type: "user" },
    autoConnect: false,
  };
  const socket: Socket = io(socketUrl, socketOptions);
  const { dispatch } = storeApi;
  if (!areListenersSet) {
    setEventListeners({ storeApi, socket, log: socketioLog });
    areListenersSet = true;
  }

  if (genGraph.match(action) || runESRGAN.match(action)) {
    if (action.payload === 'txt2img' || action.payload === 'ESRGAN') {
      //加载动画
      dispatch(progressImageSet({
        dataURL: 'st_loading.gif',
        width: 200,
        height: 200,
      }));
    }
    socket.connect();
  }
  return next(action);
};
export default socketMiddleware

function setIsProcessing(arg0: boolean): any {
  throw new Error("Function not implemented.");
}
